import 'globals';

(function (window, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        window.lazyLoadObject = new LazyLoad({
            unobserve_entered: false,
        });
    });
})(window, window.PageLoadedQueue);
